import { Logger } from './utilities/logger';
import mitt from 'mitt';
/**
 * Base for a consent option.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class AbstractOption {
    /**
     * @param {A11yConsentApi} api A11y Consent API
     * @param {AbstractGroup} group Parent group
     * @param {AbstractOptionData} data Option data from the global configuration object
     */
    constructor(api, group, data) {
        // Emits events related to the group
        this.emitter = mitt();
        this.uid = data.uid;
        Logger.debug('abstract-option', `Starting to construct "${this.uid}".`);
        this.api = api;
        this.group = group;
        this.title = data.title;
        this.description = data.description;
        Logger.debug('abstract-option', `Finished constructing "${this.uid}".`);
    }
}
